import {
  ADD_WARD_FAILURE,
  ADD_WARD_REQUEST,
  ADD_WARD_SUCCESS,
  DELETE_WARD_FAILURE,
  DELETE_WARD_REQUEST,
  DELETE_WARD_SUCCESS,
  FETCH_LIST_ALL_WARD_FAILURE,
  FETCH_LIST_ALL_WARD_REQUEST,
  FETCH_LIST_ALL_WARD_SUCCESS,
  FETCH_LIST_ALLS_WARD_FAILURE,
  FETCH_LIST_ALLS_WARD_REQUEST,
  FETCH_LIST_ALLS_WARD_SUCCESS,
  FETCH_LIST_WARD_FAILURE,
  FETCH_LIST_WARD_REQUEST,
  FETCH_LIST_WARD_SUCCESS,
  FETCH_LIST_WEEK_ID_FAILURE,
  FETCH_LIST_WEEK_ID_REQUEST,
  FETCH_LIST_WEEK_ID_SUCCESS,
  FETCH_WARD_FAILURE,
  FETCH_WARD_REQUEST,
  FETCH_WARD_SUCCESS,
  RESET_CURRENT_WARD,
  UPDATE_WARD_FAILURE,
  UPDATE_WARD_REQUEST,
  UPDATE_WARD_SUCCESS,
  FETCH_COMMON_WARD_REQUEST,
  FETCH_COMMON_WARD_SUCCESS,
  FETCH_COMMON_WARD_FAILURE,
} from "./wardType";

export const fetchWards = (blockId, floorId, pageNo) => {
  return {
    type: FETCH_LIST_WARD_REQUEST,
    payload: { blockId, floorId, pageNo },
  };
};

export const fetchWardsSuccess = (wards) => ({
  type: FETCH_LIST_WARD_SUCCESS,
  payload: { wards },
});

export const fetchWardsFailure = (error) => ({
  type: FETCH_LIST_WARD_FAILURE,
  payload: { error },
});
export const fetchAllWards = (PageNo) => {
  return {
    type: FETCH_LIST_ALL_WARD_REQUEST,
    payload:PageNo,
  };
};
export const fetchAllWardsSuccess = (wards) => {
  return {
    type: FETCH_LIST_ALL_WARD_SUCCESS,
    payload: { wards },
  };
};

export const fetchAllWardsFailure = (error) => ({
  type: FETCH_LIST_ALL_WARD_FAILURE,
  payload: { error },
});

export const fetchAllWard = (PageNo) => {
  return {
    type: FETCH_LIST_ALLS_WARD_REQUEST,
    payload:PageNo,
  };
};
export const fetchAllWardsSucces = (wards) => {
  return {
    type: FETCH_LIST_ALLS_WARD_SUCCESS,
    payload: { wards },
  };
};

export const fetchAllWardsFailures = (error) => ({
  type: FETCH_LIST_ALLS_WARD_FAILURE,
  payload: { error },
});
// View single ward
export const fetchWard = (wardId) => ({
  type: FETCH_WARD_REQUEST,
  payload: { wardId },
});

export const fetchWardSuccess = (ward) => ({
  type: FETCH_WARD_SUCCESS,
  payload: { ward },
});

export const fetchWardFailure = (error) => ({
  type: FETCH_WARD_FAILURE,
  payload: { error },
});

export const fetchWeekId = (wardId) => {

  return {
    type: FETCH_LIST_WEEK_ID_REQUEST,
    payload: { wardId },
  };
};

export const fetchWeekIdSuccess = (ward) => {

  return {
    type: FETCH_LIST_WEEK_ID_SUCCESS,
    payload: { ward },
  };
};

export const fetchWeekIdFailure = (error) => ({
  type: FETCH_LIST_WEEK_ID_FAILURE,
  payload: { error },
});

// Add ward
export const addWard = (wardData) => ({
  type: ADD_WARD_REQUEST,
  payload: { wardData },
});

export const addWardSuccess = (ward) => ({
  type: ADD_WARD_SUCCESS,
  payload: { ward },
});

export const addWardFailure = (error) => ({
  type: ADD_WARD_FAILURE,
  payload: { error },
});

// Edit ward
export const updateWard = (wardId, wardData) => ({
  type: UPDATE_WARD_REQUEST,
  payload: { wardId, wardData },
});

export const updateWardSuccess = (ward) => ({
  type: UPDATE_WARD_SUCCESS,
  payload: { ward },
});

export const updateWardFailure = (error) => ({
  type: UPDATE_WARD_FAILURE,
  payload: { error },
});

// Delete ward
export const deleteWard = (wardId) => ({
  type: DELETE_WARD_REQUEST,
  payload: { wardId },
});

export const deleteWardSuccess = (wardId) => ({
  type: DELETE_WARD_SUCCESS,
  payload: { wardId },
});

export const deleteWardFailure = (error) => ({
  type: DELETE_WARD_FAILURE,
  payload: { error },
});

// Reset current ward
export const resetCurrentWard = () => ({
  type: RESET_CURRENT_WARD,
});

export const fetchCommonWards = () => ({
  type: FETCH_COMMON_WARD_REQUEST,
});

export const fetchCommonWardsSuccess = (wards) => ({
  type: FETCH_COMMON_WARD_SUCCESS,
  payload: { wards },
});

export const fetchCommonWardsFailure = (error) => ({
  type: FETCH_COMMON_WARD_FAILURE,
  payload: { error },
});

